module.exports = __webpack_public_path__ + "frog.jpg?17d4d875c6ad54c7b1b5720845bd7f6b";